import { PropertyOperationsBuilder } from "../../../property/PropertyOperations"
import { HackleSubscriptionOperationsBuilder } from "../../../subscription/HackleSubscriptionOperations"
import { HackleSubscriptionStatus } from "../../../subscription/HackleSubscriptionStatus"
import { InAppMessageBridge } from "./InAppMessageBridge"

/**
 * install in-app message bridge to Window.
 * this bridge is used to communicate between HTML and hackle client.
 * See below for more details.
 * @example Hackle.bridge.track("eventKey", { property: "value" })
 * @example Hackle.PropertyOperationsBuilder.set("propertyKey", "value").build().toEvent("eventKey")
 * @example Hackle.HackleSubscriptionOperationsBuilder.marketing(HackleSubscriptionStatus.SUBSCRIBED).build().toRecord()
 */
export class InAppMessageBridgeInstaller {
  private static readonly HACKLE_IAM_SCRIPT_CONTAINER_NAME = "Hackle"
  private static readonly HACKLE_IAM_BRIDGE_FIELD_NAME = "bridge"

  private static readonly HACKLE_IAM_BRIDGE_READY_EVENT_NAME = "hackleBridgeReady"

  private static createBridgeReadyEvent(): Event {
    return new CustomEvent(InAppMessageBridgeInstaller.HACKLE_IAM_BRIDGE_READY_EVENT_NAME)
  }

  // window.Hackle = { bridge, PropertyOperationsBuilder, HackleSubscriptionOperationsBuilder, HackleSubscriptionStatus }
  static install(targetWindow: Window, bridge: InAppMessageBridge): void {
    ;(targetWindow as any)[InAppMessageBridgeInstaller.HACKLE_IAM_SCRIPT_CONTAINER_NAME] =
      (targetWindow as any)[InAppMessageBridgeInstaller.HACKLE_IAM_SCRIPT_CONTAINER_NAME] || {}

    Object.assign((targetWindow as any)[InAppMessageBridgeInstaller.HACKLE_IAM_SCRIPT_CONTAINER_NAME], {
      [InAppMessageBridgeInstaller.HACKLE_IAM_BRIDGE_FIELD_NAME]: bridge,
      PropertyOperationsBuilder,
      HackleSubscriptionOperationsBuilder,
      HackleSubscriptionStatus
    })

    targetWindow.dispatchEvent(InAppMessageBridgeInstaller.createBridgeReadyEvent())
  }

  static isBridgeInstalled(targetWindow: Window): boolean {
    return (
      InAppMessageBridgeInstaller.HACKLE_IAM_SCRIPT_CONTAINER_NAME in targetWindow &&
      typeof (targetWindow as any)[InAppMessageBridgeInstaller.HACKLE_IAM_SCRIPT_CONTAINER_NAME][
        InAppMessageBridgeInstaller.HACKLE_IAM_BRIDGE_FIELD_NAME
      ] !== "undefined"
    )
  }
}
